var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 7.75822C7.13776 7.75822 6.80158 7.70648 6.49121 7.62891L6.98258 14.4824C7.00848 14.7668 7.21537 14.9996 7.49984 14.9996C7.78432 14.9996 7.99121 14.7668 8.01708 14.4824L8.50845 7.62891C8.19813 7.70648 7.86192 7.75822 7.49984 7.75822Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3797 3.87932C11.3797 1.73276 9.64696 0 7.50041 0C5.35386 0 3.62109 1.73276 3.62109 3.87932C3.62109 6.02587 5.35386 7.75863 7.50041 7.75863C9.64696 7.75863 11.3797 6.02587 11.3797 3.87932Z",
    fill: "#E02126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65512 4.13552C4.49993 4.13552 4.39648 4.03207 4.39648 3.87688C4.39648 2.16999 5.79304 0.773438 7.49993 0.773438C7.65512 0.773438 7.75856 0.876885 7.75856 1.03207C7.75856 1.18726 7.65512 1.2907 7.49993 1.2907C6.07751 1.2907 4.91372 2.45449 4.91372 3.87691C4.91372 4.03207 4.81027 4.13552 4.65512 4.13552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMap);
export default __webpack_public_path__ + "static/media/view-map.92a67a8fd759a2d18176b1a1ab6bcc48.svg";
export { ForwardRef as ReactComponent };